import { Button, Card, CardContent, View } from "@/components/ui";
import type { ServiceProfileType } from "../lib";
import { inlineVisibleAttributesValue } from "../lib";
import { Typography } from "@/components/shared/typography";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

type InlineServiceCardProps =
  | {
      type: ServiceProfileType;
      profile: { name: string } & Record<string, unknown>;
      onChange: () => void;
    }
  | {
      type: "add";
      label: string;
      onChange: () => void;
    };

export const InlineServiceCard = (props: InlineServiceCardProps) => {
  const { onChange } = props;
  const { isMobile } = useWindowDimensions();

  const isAddMode = props.type === "add";
  const title = isAddMode ? undefined : props.profile.name;
  const displayText = isAddMode
    ? props.label
    : inlineVisibleAttributesValue(props.profile, props.type);
  const actionLabel = isAddMode ? "Add" : "Change";

  return (
    <Card onClick={isMobile ? onChange : undefined}>
      <CardContent className="flex flex-row items-center justify-between">
        <View className="native:max-w-[250px] flex flex-col gap-2">
          {title && <Typography variant="body-md">{title}</Typography>}
          <Typography variant="body-md" color="secondary-text">
            {displayText}
          </Typography>
        </View>
        <Button
          variant="link"
          color="CTA2"
          className="p-0"
          iconColor={isAddMode ? "CTA2" : "foreground"}
          iconAlignment="end"
          iconName={isAddMode ? "plus" : "caretRight"}
          onClick={onChange}
        >
          {actionLabel}
        </Button>
      </CardContent>
    </Card>
  );
};
